import {Component, Input, ViewEncapsulation} from '@angular/core';
import {Product} from '../../../../models/product.model';

@Component({
  selector: 'app-product-details-cell',
  templateUrl: './product-details-cell.component.html',
  styleUrls: ['./product-details-cell.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductDetailsCellComponent {
  @Input() product: Product;
}
